<template lang="html">
	<div class="campaign-type-filter__option">
		<button class="title-button" :class="{ active: visible }" @click="toggleVisible">{{ title }}</button>
		<div v-if="visible" class="options-list">
			<div v-for="option in filteredOptions" :key="option.id" class="option">
				<label class="omapi-checkbox" @input="setTaxonomyFilter(slug, option)">
					<input type="checkbox" :value="option.id" :checked="filterSet(slug, option)" />
					<span class="omapi-checkbox__input"></span>
					{{ option.name }}
				</label>
			</div>
		</div>
	</div>
</template>

<script lang="js">
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapGetters } = createNamespacedHelpers('templates');

export default {
	props: {
		title: {
			type: String,
			default: 'Filter Title',
		},
		slug: {
			type: String,
			default: '',
		},
		options: {
			type: Array,
			default: () => [],
		},
		showOptions: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			visible: this.showOptions,
		};
	},
	computed: {
		...mapState(['search']),
		...mapGetters(['filters']),
		/**
		 * Filter the option to only include those with templates.
		 *
		 * @returns {Array} The filtered options.
		 */
		filteredOptions() {
			return this.options.filter((option) => this.hasTemplates(option));
		},
	},
	methods: {
		/**
		 * Determine if the given filter is set/active.
		 *
		 * @param {string} filter The filter's slug.
		 * @param {object} option The option object.
		 *
		 * @returns {boolean} True if the filter is set.
		 */
		filterSet(filter, option) {
			return this.filters[filter].includes(option.id);
		},
		/**
		 * Toggle the visibility of the options.
		 *
		 * @returns {void}
		 */
		toggleVisible() {
			this.visible = !this.visible;
		},
		/**
		 * Determine if the option has templates.
		 *
		 * @param {object} option The option to check.
		 *
		 * @returns {boolean} True if the option has templates.
		 */
		hasTemplates(option) {
			return 0 < option.templates_count;
		},
		/**
		 * Set the taxonomy filter.
		 *
		 * @param {string} filter The filter's slug.
		 * @param {object} option The option object.
		 *
		 * @returns {void}
		 */
		setTaxonomyFilter(filter, option) {
			const value = [...this.filters[filter]];
			const index = value.indexOf(option.id);

			if (-1 !== index) {
				value.splice(index, 1);
			} else {
				value.push(option.id);
			}

			this.$store.commit('templates/setFilter', { filter, value: value });

			this.$emit('scrollTop');
		},
	},
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables';

.campaign-type-filter__option {
	.title-button {
		border: 0;
		background: transparent;
		color: $color_black;
		font-weight: 700;
		font-size: 16px;
		margin-bottom: 16px;
		padding: 0;
		position: relative;
		width: 100%;
		text-align: left;

		&:hover {
			cursor: pointer;
		}

		&:after {
			content: url('./../../assets/images/icons/expand-more.svg');
			border: none;
			display: block;
			transform: rotate(180deg);
			position: absolute;
			top: 0;
			right: 0;
		}

		&.active {
			&:after {
				transform: rotate(0deg);
			}
		}
	}
	.options-list {
		margin-bottom: 24px;
		.omapi-checkbox {
			font-size: 14px;
			margin-bottom: 16px;

			.omapi-checkbox__input {
				color: $font_dark-color;
			}
		}
	}
}
</style>
